import { Button, Container } from 'react-bootstrap';
import { useState, useEffect } from 'react';
// Make sure to import the CSS file we just made. 
// Adjust the path depending on where you saved the CSS.
import '../../Stylesheet/Karol.css'; 

const KarolResult = () => {
    // 0 = Start Screen
    // 1 = First dialogue
    // 2 = Second dialogue
    // 3 = Third dialogue
    // 4 = Result Reveal
    const [step, setStep] = useState(0);

    // The Script
    const dialogues = [
        "Hi, Karol! Are you excited to know the result of your bar exam?",
        "Can't really sleep well until this day?",
        "Well, your troubles are now over! Maybe get troubled again taking the exam or not ...",
        "But! We know you've done all you can and just know that you did all your best! What matters most is that you've no regrets doing the best you can.",
        "Alrighty! Without further ado, here is your result ..."
    ];

    useEffect(() => {
        // Change the title when the component mounts
        document.title = "Results for Karol";

        // (Optional) Change it back to "Jerico Radin" when she leaves this page
        return () => {
            document.title = "Jerico Radin";
        };
    }, []);

    const handleNext = () => {
        setStep(prevStep => prevStep + 1);
    };

    // Helper to render the content based on current 'step'
    const renderContent = () => {
        // --- PHASE 1: START SCREEN ---
        if (step === 0) {
            return (
                <div className='text-center'>
                    <h1 className='mb-4'>Welcome, Karol!</h1>
                    <Button 
                        variant="info" 
                        size="lg" 
                        className="btnSizeUp"
                        onClick={handleNext}
                    >
                        START
                    </Button>
                </div>
            );
        }

        // --- PHASE 2: DIALOGUE (Looping through array) ---
        // We use (step - 1) because our step starts at 1 for dialogues, but array starts at 0
        if (step > 0 && step <= dialogues.length) {
            return (
                <div className="dialogue-window" onClick={handleNext}>
                    <div>
                        {/* Optional: Add a speaker name if you want */}
                        {/* <strong style={{color: '#5bc0de'}}>Friend:</strong><br/><br/> */}
                        <p className="dialogue-text">
                            {dialogues[step - 1]}
                        </p>
                    </div>
                    <div className="tap-hint">
                        (Tap anywhere to continue ▶)
                    </div>
                </div>
            );
        }

        // --- PHASE 3: THE RESULT REVEAL ---
        if (step > dialogues.length) {
            return (
                <div className="dialogue-window result-reveal">
                    <h1>CONGRATULATIONS,<br/>ATTY. KAROL PAULENE ESLAVA!</h1>
                    <div className="passed-text">
                        YOU PASSED!
                    </div>
                    <p>Attorney-at-Law</p>
                    <Button 
                        variant="outline-primary" 
                        size="sm" 
                        onClick={() => setStep(0)}
                    >
                        Replay
                    </Button>
                </div>
            );
        }
    };

    return (
        <div className="karol-background">
            <Container>
                <div className="d-flex justify-content-center">
                    {renderContent()}
                </div>
            </Container>
        </div>
    );
}

export default KarolResult;